export function baseInfo() {
    return {
        dept: '茂名市人力资源和社会保障局', // 部门名称
        reward: '', // 奖励
        health: '', // 身体状况
        graduationSchoolAndDate: '', // 毕业学校
        evaluateRecord: ''	// 奖惩记录
    }
}

/**
 * 初始化 学生信息 数据
 * @param {number, number} familyCount 家庭成员数量, evaluate 评价数量
 * @returns Object
 */
export function initBasicCardData(familyCount = 5, evaluate = 7) {
    let familyObj = {
        id: '',
        sex: '',	// 性别
        relationship: '',	// 关系
        politics: '',	// 政治面貌
        workUnit: '',	// 何处工作
        workPosition: '',	// 职务
        remark: ''	// 备注
    }
    let familyList = []
    for (let i = 0; i < familyCount; i++) {
        familyObj.id = i + 1
        familyList.push(JSON.parse(JSON.stringify(familyObj)))
    }

    let evaluateObj = {
        id: '',
        semester: '',	// 第1学期
        evaluate: ''	// 评价
    }
    let evaluateList = []
    for (let i = 0; i < evaluate; i++) {
        evaluateObj.id = i + 1
        evaluateList.push(JSON.parse(JSON.stringify(evaluateObj)))
    }
    return {
        familyList: familyList,
        evaluateList: evaluateList
    }
}

/**
 * 初始化 学业成绩 数据
 * @param {number} semesterCount 学期数
 * @returns Object
 */
export function initCourseCardData(semesterCount = 12, timeCardCount = 4, otherSituationsCount = 10) {
    let semesterObj = {
        semester1: '',	midScore1: '', endScore1: '',	score1: '', semester2: '',	midScore2: '', endScore2: '',	score2: '',
        semester3: '',	midScore3: '', endScore3: '',	score3: '', semester4: '',	midScore4: '', endScore4: '',	score4: '',
        semester5: '',	midScore5: '', endScore5: '',	score5: '', semester6: '',	midScore6: '', endScore6: '',	score6: ''
    }
    let semesterList = []
    for (let i = 0; i < semesterCount; i++) {
        semesterList.push(JSON.parse(JSON.stringify(semesterObj)))
    }

    let timecardObj = {
        id: '', field1: '', field2: '', field3: '', field4: '', field5: '', field6: ''

    }
    let timecardList = []
    for (let i = 0; i < timeCardCount; i++) {
        timecardObj.id = i + 1
        timecardList.push(JSON.parse(JSON.stringify(timecardObj)))
    }

    let otherSituationsList = []
    for (let i = 0; i < otherSituationsCount; i++) {
        let obj = {
            internshipNum: '', internshipName: '', internshipScore: ''
        }
        otherSituationsList.push(obj)
    }

    let otherSituationsObj = {
        otherTime: '', otherResult: '', otherNum: '', field7: '', field8: '', field9: '', field10: '', field11: ''
    }

    return {
        semesterList: semesterList,
        timecardList: timecardList,
        otherSituationsList: otherSituationsList,
        otherSituationsObj: otherSituationsObj
    }
}
